import loadable from '@loadable/component';
import { loadableOptions } from '@utils/helpers';

const Patient = {
  Orders: loadable(() => import('./Orders'), loadableOptions),
};

export default Patient;
